// Use $ instead of $ without replacing global $
(function ($) {


  $(document).ready(function () {
    if ($('.page-node-2').length > 0) {
      $('.col-two-block').each(function () {
        // console.log(this);
        $(this).addClass('pt-0');
      });

      $('.col-two-block:eq(0)').removeClass('pt-0');
    }
  });

})(jQuery);